<template>
  <div class="period-select">
    <div class="title-period-menu">
      <div class="text title">
        Швидка навiгацiя по архiву
      </div>
    </div>
    <div class="buttons">
      <button type="button" class="period-button text" @click="period('0')">Зараз</button>
      <button type="button" class="period-button text" @click="period('10')">10 хв. тому</button>
      <button type="button" class="period-button text" @click="period('60')">Годину тому</button>
      <button type="button" class="period-button text" @click="period('480')">8 годин тому</button>
      <button type="button" class="period-button text" @click="period('720')">12 годин тому</button>
      <button type="button" class="period-button text" @click="period('1440')">24 години тому</button>
    </div>
  </div>  
</template>


<script>

export default {

  name: "PeriodSelectComponent",

  props: ['selected_period'],

  data () {
    return {
    }
  },

  methods: {
    period (set_period) {
      this.selected_period({
        set_period:set_period
      })
    }
  }

}
</script>


<style scoped>

.period-select {
   width: 265px;
  /*display: grid; */
  /* grid-template-rows: 0.1fr 1fr 2fr auto; */
  /* grid-template-columns:  1fr 1fr; */
  /* justify-items: center; */
  /* grid-template-areas: 
  "title title"
  "buttons buttons" */
  ;
}

.buttons {
  display: grid; 
  grid-template-columns:  1fr 1fr;
  gap: 5px;
}

.title-period-menu{
  width: 265px;
  height: 30px;
  margin-bottom: 15px;
  background: #383838;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
}

.title {
  padding-top: 7px;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
}

.period-button {
  display: inline-block;
  border: none;
  /* width: 165px; */
  width: 130px;
  height: 31px;
  cursor: pointer;
  /* margin-bottom: 10px; */
  background: #848484;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
  font-size: 13px;
}

.period-button:hover {
  background: #696969;
}


</style>